import React from 'react';
import clsx from 'clsx';
import {
    CancelButton,
    ConfirmButton,
    NameTextField
} from '../../../../../../styling/Styles';
import {
    checkIfEmpty,
    checkDublicateBlockName,
    checkHasSpaces
} from "../../../../../../validations/validations"

const GenerateListBlock = (props) => {

    const {
        producedBlockName,
        setProducedBlockName,
        componentsInfo,
        name,
        editor,
        selectedProject,
        savedPageClicked,
        setOpenAlert,
        setOpenSnackBar,
        setClickedButtonGenerate
    } = props


    //  This function returns the index of the  project's data element  that we going to connect the generated block.
    const findIndexOfEditDataModel = () => {

        let indexDataModel = -1
        const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].data_elements.data_elements_info;
        tempData.forEach( (dataModel,index2) => {
            if(dataModel.dataName === name ){
                indexDataModel = index2;
            }
        })
        return indexDataModel;
    }

    //  This functions generates a new block based on the edited list
    const generateBlock = () => {
        //  Validations if tre given new block's name already exists, or is empty or has spaces
        
        if( checkIfEmpty(producedBlockName) === false && checkDublicateBlockName(producedBlockName, editor) === false && checkHasSpaces() === false){
            const tempContent = [];

            //  Parse all rows of the edited list
            componentsInfo.forEach( (insideComp, indexInsideComp) => {
                
                const { hrefChecked } = componentsInfo[indexInsideComp].info;
                const { targetPageChecked } = componentsInfo[indexInsideComp].info;
                const imageAttributes = {
                    src: componentsInfo[indexInsideComp].info.imageSrc,
                    alt: 'Image'
                }

                if(hrefChecked === true){
                    const { href } = componentsInfo[indexInsideComp].info;
                    if( href !== ''){
                        imageAttributes.href = href
                    }
                    
                }
                else if(targetPageChecked === true){
                    const { targetPage } = componentsInfo[indexInsideComp].info;
                    if(targetPage !== '' && targetPage !== 'undefined'){
                        imageAttributes.target_page = targetPage
                    }
                } 

                tempContent.push({  
                    type: 'row',
                    tagName: 'tr',
                    components: [
                        {
                          type: 'cell', 
                          tagName: 'td', 
                          components: [
                            {   
                                type: 'image', 
                                attributes: imageAttributes,
                                classes: ["list-item-image"],
                            }
                          ],
                          classes: ['list-cell-left']
                        },
                        {
                          type: 'cell', 
                          tagName: 'td', 
                          components: [
                            {tagName: 'h1', content: componentsInfo[indexInsideComp].info.titleText, classes:['card-title']},
                            {tagName: 'p', content: componentsInfo[indexInsideComp].info.descriptionText, classes:['card-text']},
                            ],
                          classes: ['list-cell-right']
                          },
                    ],
                    
                    classes: ["list-item-content"]
                  
                })

            })

            //  Creation of  the content of the produced block
            const tempTableContent = {
                type: 'tableList',   
                components: [{
                    type: 'tbody',
                    components: tempContent
                }],
                attributes:{
                    'name': name
                }
            }
            
            // Add the generated block to blocks of GrapesJs BlockManager
            editor.BlockManager.add(producedBlockName,{
                label: `${producedBlockName} Block`,
                content: tempTableContent,
                category: {
                    label: 'Extra ',
                    open: 'false',
                },
            });
            
            //  Add info of the generated block to project's data in localeStorage so as to render and delete it according to selected Project
            const tempData = JSON.parse(localStorage.getItem('data'))
            const tempDataElementBlock = {
                'id': producedBlockName,
                'content': tempTableContent,
                'label': `${producedBlockName} Block`,
                'category': {
                    label: 'Extra ',
                    open: 'false',
                }
            }
            const indexOfDataModel = findIndexOfEditDataModel();
            if(indexOfDataModel > -1){
                tempData[selectedProject].data_elements.data_elements_blocks[indexOfDataModel].blocks.push(tempDataElementBlock)
            }
            
            localStorage.setItem('data',JSON.stringify(tempData));    
            savedPageClicked();
            setOpenAlert(false);
            setOpenSnackBar(true);
            setClickedButtonGenerate(false);
        }
        
    }

    //  This function changes the value of the block name that we are going to generate
    const handleBlockName = (e) => {
        setProducedBlockName(e.target.value);
    }

    /*
    This functions is connected with the 'Cancel' button of the pop up window that we give the name of the new block and when is clicked
    the edit list window is displayed 
    */
    const deactivateGenerateButton = () => {
        setClickedButtonGenerate(false);
    }

    return(
        <div >
            <div className={clsx('titlePopUp','paddingTitle')}> Generate block</div>
            <div className = {clsx('paddingTitle')}>
                <div className={clsx('flexRowDirection')}>
                    <span>Block name: &nbsp;</span>        
                    <NameTextField
                        placeholder='block name'
                        error={checkIfEmpty(producedBlockName) === true|| checkDublicateBlockName(producedBlockName, editor) === true || checkHasSpaces() === true}
                        helperText = {
                            checkIfEmpty(producedBlockName) === true ? 'Block name is empty' :
                            (
                                checkDublicateBlockName(producedBlockName,editor) === true && 'Block name exists'
                            )
                        }
                        value={producedBlockName}
                        onInput={e => handleBlockName(e)}
                    />
                </div>
                <div className={clsx('flex-container', 'spacingDownDiv')} 
                    style={{
                        justifyContent:'space-between',
                        display: 'flex',
                        flexDirection: 'row', 
                        marginTop: '1vw',
                        minWidth: '20vw'
                    }}

                >
                    <div >
                        <CancelButton onClick={deactivateGenerateButton}>
                            Cancel
                        </CancelButton >
                    </div>
                    <div className={clsx('flexRowDirection')}>
                        <ConfirmButton
                        onClick={generateBlock}
                        >
                            Generate 
                        </ConfirmButton>
                    </div>
                </div>
            </div>  
        </div>

    )

}

export default GenerateListBlock;